import { ComponentType, FC } from 'react'
import { HasRequiredPermissions } from '../HasRequiredPermissions'
import { WithRequiredPermissionsProps } from '../types/Permissions'

export function withRequiredPermissions<
  Action extends string = string,
  Subject extends string = string,
  Props extends object = object,
>(
  Component: ComponentType<Props>,
  {
    requiredPermissions,
    Forbidden,
  }: WithRequiredPermissionsProps<Action, Subject> & { Forbidden: FC }
) {
  const displayName = Component.displayName || Component.name || 'Component'

  function ComponentWithRequiredPermissions(props: Props) {
    return (
      <HasRequiredPermissions passThrough requiredPermissions={requiredPermissions}>
        {(isAllowed) => (isAllowed ? <Component {...props} /> : <Forbidden />)}
      </HasRequiredPermissions>
    )
  }

  ComponentWithRequiredPermissions.displayName = `withRequiredPermissions(${displayName})`

  return ComponentWithRequiredPermissions
}
